import { NavigatorLayoutState } from '../types';

export const isDisplayedAndTreeHasComponents =
  (componentIds: string[]) =>
  (
    navigatorState: NavigatorLayoutState
  ): navigatorState is NavigatorLayoutState & { container: HTMLElement } => {
    const { container, tree } = navigatorState;
    return Boolean(
      container &&
      container.offsetHeight > 0 &&
      componentIds.every(componentId => tree.hasNode(componentId))
    );
  };
